import { Box, Collapse, IconButton, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Icons } from '../../../shared/utils/icons.jsx'
import { markdownToText } from '../../../shared/utils/helpers.jsx'
import CustomMarkdown from './CustomMarkdown'

const AiResponseBox = ( { responseDetails } ) => {

    const [collapseState, setCollapseState] = useState( false )
    const [listening, setListening] = useState( false )
    const [listeningPaused, setListeningPaused] = useState( false )

    const { palette, border, layout } = useTheme()


    const listenToResponse = ( event, aiResponse ) => {
        event.stopPropagation()
        if ( !listening ) {
            if ( speechSynthesis.speaking )
                speechSynthesis.cancel()
            const speechText = markdownToText( aiResponse )
            const utterance = new SpeechSynthesisUtterance( speechText )
            utterance.onpause = () => setListeningPaused( true )
            utterance.onresume = () => setListeningPaused( false )
            utterance.onend = () => setListening( false )
            utterance.onerror = () => setListening( false )
            const voices = speechSynthesis.getVoices()
            utterance.voice = voices[0]
            speechSynthesis.speak( utterance )
            setListening( true )
        }
    }

    const toggleListening = ( event ) => {
        event.stopPropagation()
        if ( !speechSynthesis.paused ) {
            speechSynthesis.pause()
        } else {
            speechSynthesis.resume()
        }
    }

    const stopListening = ( event ) => {
        event.stopPropagation()
        speechSynthesis.cancel()
        setListening( false )
    }

    useEffect( () => {
        const stopListening = () => {
            speechSynthesis.cancel()
            setListening( false )
        }
        return () => stopListening()
    }, [] )

    return (
        <Box
            sx={{
                borderRadius: layout.borderRadius,
                overflow: "clip",
                border: border[1]
            }}>
            <Box
                onClick={() => setCollapseState( prev => !prev )}
                sx={{
                    padding: "10px",
                    gap: layout.cardsGap,
                    flexWrap: "wrap",
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: border[1],
                    cursor: "pointer",
                    ":hover": { bgcolor: palette.rowHover }
                }}>
                <Box>
                    <Typography variant="h6" component="p" sx={{
                        fontSize: "16px"
                    }}><strong>Explain {responseDetails.topic.topic}</strong></Typography>
                    <Typography variant="subtitle2" color="GrayText" sx={{
                        marginTop: "-5px"
                    }}>From: <em>{responseDetails.topic?.subject_name}, {responseDetails.topic?.module}</em></Typography>
                </Box>
                <Box
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        gap: "20px"
                    }}>
                    {<Box
                        sx={{
                            display: "flex",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            bgcolor: palette.secondary.main,
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "pointer"
                        }}>
                        <Box
                            onClick={( event ) => listenToResponse( event, responseDetails.response )}
                            sx={{
                                color: palette.secondary.contrastText,
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                            }}>
                            {listening ? Icons.small.GraphicEqRounded : Icons.small.VolumeUpIcon}
                            <Typography variant="subtitle2" color={palette.secondary.contrastText} >{listening ? "Listening" : "Listen"}</Typography>
                        </Box>
                        {listening && <IconButton sx={{ color: palette.secondary.contrastText }} onClick={toggleListening} size="small">{listeningPaused ? Icons.default.PlayArrowIcon : Icons.default.PauseIcon}</IconButton>}
                        {listening && <IconButton sx={{ color: palette.secondary.contrastText }} onClick={stopListening} size="small">{Icons.default.Stop}</IconButton>}
                    </Box>}
                    <IconButton>
                        {collapseState ? Icons.default.KeyboardArrowUp : Icons.default.KeyboardArrowDownIcon}
                    </IconButton>
                </Box>
            </Box>
            <Collapse in={collapseState}>
                <Box sx={{
                    padding: "20px"
                }} >
                    <CustomMarkdown content={responseDetails.response || ""} />
                </Box>
            </Collapse>
        </Box>
    );
}

export default AiResponseBox
